export default __webpack_public_path__ + "css/coreModules.bundle.css";